// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { FC, useRef } from 'react';
import { CKEditor as Editor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ToolbarConfig } from '@ckeditor/ckeditor5-core/src/editor/editorconfig';

import { CustomUploadAdapter } from 'utils/customUploadAdapter';

interface IProps {
  value?: string;
  toolbar?: ToolbarConfig;
  onChange?(value: string): void;
  disabled?: boolean;
}

const CKEditor: FC<IProps> = ({ value, toolbar = {}, disabled, onChange }) => {
  const ref = useRef<ClassicEditor>();

  return (
    <Editor
      disabled={disabled}
      editor={ClassicEditor}
      data={value || ''}
      onReady={editor => {
        ref.current = editor;

        editor.plugins.get('FileRepository').createUploadAdapter = loader => {
          return new CustomUploadAdapter(loader);
        };
      }}
      config={{
        extraPlugins: [CustomUploadAdapter],
        mediaEmbed: {
          previewsInData: true
        },
        toolbar
      }}
      onChange={() => {
        onChange?.(ref.current?.getData() || '');
      }}
    />
  );
};

export default CKEditor;
